/* tslint:disable */
/* eslint-disable */
/**
 * NLBS SDPS Secure Zone API
 * NLBS SDPS Secure Zone API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CheckPsuResponseBody,
  CreateResponseBody,
  RejectRequestBody,
  RequestRequestBody,
} from '../models';
import {
    CheckPsuResponseBodyFromJSON,
    CheckPsuResponseBodyToJSON,
    CreateResponseBodyFromJSON,
    CreateResponseBodyToJSON,
    RejectRequestBodyFromJSON,
    RejectRequestBodyToJSON,
    RequestRequestBodyFromJSON,
    RequestRequestBodyToJSON,
} from '../models';

export interface DownloadsApproveRequest {
    uuid: string;
}

export interface DownloadsCancelRequest {
    uuid: string;
    rejectRequestBody: RejectRequestBody;
}

export interface DownloadsRejectRequest {
    uuid: string;
    rejectRequestBody: RejectRequestBody;
}

export interface DownloadsRequestRequest {
    requestRequestBody: RequestRequestBody;
}

export interface DownloadsRetrieveRequest {
    uuid: string;
}

export interface DownloadsRetryRequest {
    uuid: string;
}

/**
 * DownloadsApi - interface
 * 
 * @export
 * @interface DownloadsApiInterface
 */
export interface DownloadsApiInterface {
    /**
     * Approve a download
     * @summary approve downloads
     * @param {string} uuid Download UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadsApiInterface
     */
    downloadsApproveRaw(requestParameters: DownloadsApproveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Approve a download
     * approve downloads
     */
    downloadsApprove(requestParameters: DownloadsApproveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Cancel a download
     * @summary cancel downloads
     * @param {string} uuid Download UUID
     * @param {RejectRequestBody} rejectRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadsApiInterface
     */
    downloadsCancelRaw(requestParameters: DownloadsCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Cancel a download
     * cancel downloads
     */
    downloadsCancel(requestParameters: DownloadsCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Check the PSU information since the last PSU
     * @summary check-psu downloads
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadsApiInterface
     */
    downloadsCheckPsuRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckPsuResponseBody>>;

    /**
     * Check the PSU information since the last PSU
     * check-psu downloads
     */
    downloadsCheckPsu(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckPsuResponseBody>;

    /**
     * Reject a download
     * @summary reject downloads
     * @param {string} uuid Download UUID
     * @param {RejectRequestBody} rejectRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadsApiInterface
     */
    downloadsRejectRaw(requestParameters: DownloadsRejectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Reject a download
     * reject downloads
     */
    downloadsReject(requestParameters: DownloadsRejectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Request a download
     * @summary request downloads
     * @param {RequestRequestBody} requestRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadsApiInterface
     */
    downloadsRequestRaw(requestParameters: DownloadsRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateResponseBody>>;

    /**
     * Request a download
     * request downloads
     */
    downloadsRequest(requestParameters: DownloadsRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateResponseBody>;

    /**
     * Retrieve a download
     * @summary retrieve downloads
     * @param {string} uuid Download UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadsApiInterface
     */
    downloadsRetrieveRaw(requestParameters: DownloadsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Retrieve a download
     * retrieve downloads
     */
    downloadsRetrieve(requestParameters: DownloadsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Retry a failed download
     * @summary retry downloads
     * @param {string} uuid Download UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadsApiInterface
     */
    downloadsRetryRaw(requestParameters: DownloadsRetryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Retry a failed download
     * retry downloads
     */
    downloadsRetry(requestParameters: DownloadsRetryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class DownloadsApi extends runtime.BaseAPI implements DownloadsApiInterface {

    /**
     * Approve a download
     * approve downloads
     */
    async downloadsApproveRaw(requestParameters: DownloadsApproveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling downloadsApprove.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/downloads/{uuid}/approve`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Approve a download
     * approve downloads
     */
    async downloadsApprove(requestParameters: DownloadsApproveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.downloadsApproveRaw(requestParameters, initOverrides);
    }

    /**
     * Cancel a download
     * cancel downloads
     */
    async downloadsCancelRaw(requestParameters: DownloadsCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling downloadsCancel.');
        }

        if (requestParameters.rejectRequestBody === null || requestParameters.rejectRequestBody === undefined) {
            throw new runtime.RequiredError('rejectRequestBody','Required parameter requestParameters.rejectRequestBody was null or undefined when calling downloadsCancel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/downloads/{uuid}/cancel`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RejectRequestBodyToJSON(requestParameters.rejectRequestBody),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel a download
     * cancel downloads
     */
    async downloadsCancel(requestParameters: DownloadsCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.downloadsCancelRaw(requestParameters, initOverrides);
    }

    /**
     * Check the PSU information since the last PSU
     * check-psu downloads
     */
    async downloadsCheckPsuRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckPsuResponseBody>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/downloads/check-psu`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckPsuResponseBodyFromJSON(jsonValue));
    }

    /**
     * Check the PSU information since the last PSU
     * check-psu downloads
     */
    async downloadsCheckPsu(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckPsuResponseBody> {
        const response = await this.downloadsCheckPsuRaw(initOverrides);
        return await response.value();
    }

    /**
     * Reject a download
     * reject downloads
     */
    async downloadsRejectRaw(requestParameters: DownloadsRejectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling downloadsReject.');
        }

        if (requestParameters.rejectRequestBody === null || requestParameters.rejectRequestBody === undefined) {
            throw new runtime.RequiredError('rejectRequestBody','Required parameter requestParameters.rejectRequestBody was null or undefined when calling downloadsReject.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/downloads/{uuid}/reject`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RejectRequestBodyToJSON(requestParameters.rejectRequestBody),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reject a download
     * reject downloads
     */
    async downloadsReject(requestParameters: DownloadsRejectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.downloadsRejectRaw(requestParameters, initOverrides);
    }

    /**
     * Request a download
     * request downloads
     */
    async downloadsRequestRaw(requestParameters: DownloadsRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateResponseBody>> {
        if (requestParameters.requestRequestBody === null || requestParameters.requestRequestBody === undefined) {
            throw new runtime.RequiredError('requestRequestBody','Required parameter requestParameters.requestRequestBody was null or undefined when calling downloadsRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/downloads/request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestRequestBodyToJSON(requestParameters.requestRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateResponseBodyFromJSON(jsonValue));
    }

    /**
     * Request a download
     * request downloads
     */
    async downloadsRequest(requestParameters: DownloadsRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateResponseBody> {
        const response = await this.downloadsRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a download
     * retrieve downloads
     */
    async downloadsRetrieveRaw(requestParameters: DownloadsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling downloadsRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/downloads/{uuid}/retrieve`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Retrieve a download
     * retrieve downloads
     */
    async downloadsRetrieve(requestParameters: DownloadsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retry a failed download
     * retry downloads
     */
    async downloadsRetryRaw(requestParameters: DownloadsRetryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling downloadsRetry.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/downloads/{uuid}/retry`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Retry a failed download
     * retry downloads
     */
    async downloadsRetry(requestParameters: DownloadsRetryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.downloadsRetryRaw(requestParameters, initOverrides);
    }

}
